import React, { useState, useEffect, useContext } from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import '../../css/general.css'
import '../../css/inventory.css';
import Card from 'react-bootstrap/Card';
import { EventActionType } from '../../Constants/StorageConstants';

const ExtraInfoSection = (props) => {
    const { t } = useTranslation();
    const [seller, setSeller] = useState('');
    const [sellerContact, setSellerContact] = useState('');
    const [supplier, setSupplier] = useState('');
    const [supplierContact, setSupplierContact] = useState('');
    const [sameAsSeller, setSameAsSeller] = useState(false);
    const [deliveryChecked, setDeliveryChecked] = useState(false);
    const [explanation, setExplanation] = useState('');

    useEffect(() => {
        validateExtraInfoSection();
    }, [seller, sellerContact, supplier, supplierContact, sameAsSeller, deliveryChecked, explanation,
        props.purchaseListObject.purchaseObject.eventType, 
        props.purchaseListObject.purchaseObject.operationType]);

    const validateExtraInfoSection = () => {
        var isValid = true;

        if (props.purchaseListObject.purchaseObject.eventType === EventActionType.Purchase) {
            // Set validations here. Currently no validations.
        }

        // Update context values
        var updateObject = {
            type: 'UPDATE',
            purchaseObject: {
                seller: seller,
                sellerContact: sellerContact,
                supplier: sameAsSeller ? seller : supplier,
                supplierContact: sameAsSeller ? sellerContact : supplierContact,
                deliveryChecked: deliveryChecked,
                extraInfo: explanation
            },
            sectionValidation: {
                extraInfoSection: isValid
            }
        };
        props.updatePurchaseObject(updateObject);
    }

    return (
        <>
            <Form.Group controlId="formAdditionalInformation">
                
                {props.purchaseListObject.purchaseObject.eventType === EventActionType.Purchase ? 
                    <>
                        <Form.Label className="text-dark purchase-section-header">{t('PurchaseList_Seller')}</Form.Label>
                        <Form.Control type="text" onChange={(event) => { setSeller(event.target.value) }}
                            value={seller}
                            placeholder={t('NoteDescription')}
                            maxLength={100} />
                        <div className="char-counter">{seller.length}/100</div>

                        <Form.Label className="text-dark purchase-section-header">{t('PurchaseList_ContactInfo')}</Form.Label>
                        <Form.Control type="text" onChange={(event) => { setSellerContact(event.target.value) }}
                            value={sellerContact}
                            placeholder={t('NoteDescription')}
                            maxLength={500} />
                        <div className="char-counter">{sellerContact.length}/500</div>

                        <br />

                        <Card.Body className={"silo-transfer-content"}>
                            <Form key={"silo-transfer-form"}>
                                <Form.Group controlId="silo-transfer" disabled={sameAsSeller}>
                                    <Form.Check
                                        checked={sameAsSeller}
                                        onChange={() => setSameAsSeller(!sameAsSeller)}
                                        type={'switch'}
                                        label={t('PurchaseList_SupplierSameAsSeller')}
                                        id="same-as-seller"
                                        className="change-plant-switch purchase-switch"
                                    />

                                    <Form.Label disabled={sameAsSeller} className="text-dark purchase-section-header">{t('PurchaseList_Supplier')}</Form.Label>
                                    <Form.Control type="text" onChange={(event) => { setSupplier(event.target.value) }}
                                        disabled={sameAsSeller}
                                        value={supplier}
                                        placeholder={sameAsSeller ? seller : ''}
                                        maxLength={100} />
                                    {sameAsSeller ? '' : <div className="char-counter">{supplier.length}/100</div>}

                                    <Form.Label disabled={sameAsSeller} className="text-dark purchase-section-header">{t('PurchaseList_ContactInfo')}</Form.Label>
                                    <Form.Control type="text" onChange={(event) => { setSupplierContact(event.target.value) }}
                                        disabled={sameAsSeller}
                                        value={supplierContact}
                                        placeholder={sameAsSeller ? sellerContact : ''}
                                        maxLength={500} />
                                    {sameAsSeller ? '' : <div className="char-counter">{supplierContact.length}/500</div>}
                                </Form.Group>
                            </Form>
                        </Card.Body>

                        <br />

                        <Form.Check
                            checked={deliveryChecked}
                            onChange={() => setDeliveryChecked(!deliveryChecked)}
                            type={'switch'}
                            label={t('PurchaseList_DeliveryChecked')}
                            id="delivery-checked"
                            className="change-plant-switch purchase-switch"
                        />
                    </>
                    : ''}

                <Form.Label className="text-dark purchase-section-header">{t('NoteDescription')}</Form.Label>
                <Form.Control type="text" onChange={(event) => { setExplanation(event.target.value) }}
                    value={explanation}
                    placeholder={t('NoteDescription')}
                    maxLength={2500} />
                <div className="char-counter">{explanation.length}/2500</div>
            </Form.Group>
        </>
    )
}

export default ExtraInfoSection;